import React, { HTMLAttributes } from 'react';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import { WysiwygField, VideoPopup } from '../../../components';
import type { ParagraphAvOWinnersProps as Type } from '../../../types/uncinc_profile/paragraphs';

import { SCREEN_MOBILE, SCREEN_NORMAL } from '../../../config/constants';

import './style.scss';

interface ParagraphAvOWinnersProps
  extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphAvOWinners: React.FC<ParagraphAvOWinnersProps> = ({
  entity,
}) => {
  const headTitle = entity.getIn(['field_title', 0, 'value']);
  const items = entity.toJS().field_field_item;

  return (
    <div className="Paragraph ParagraphAvOWinners">
      <Container>
        <div className="row">
          <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
            <div className="ParagraphAvOWinners__inner">
              <h2 className="ParagraphAvOWinners__title">{headTitle}</h2>
              <div className="ParagraphAvOWinners__items">
                {items.map(({ entity: item }) => {
                  const title = item.field_title[0].value;
                  const body = item.field_body[0].value;
                  const videoId = item.field_video[0]?.target_id ?? 0;
                  const videoField = item.field_video?.[0];
                  const language = item.langcode[0]?.value;
                  const embedUrl =
                  item.field_video[0]?.entity.field_media_video_embed_field[0]
                    .value;
                  const thumbnailMobile = videoField?.styles?.ratio_16_9_lg;
                  const thumbnailDesktop = videoField?.styles?.teaser_image;

                  return (
                    <div className="ParagraphAvOWinners__item">
                      <div className="ParagraphAvOWinners__content">
                        <h3 className="ParagraphAvOWinners__item__title">
                          {title}
                        </h3>
                        <WysiwygField
                          property="schema:text"
                          className="ParagraphAvOWinners__body"
                          html={body}
                        />
                      </div>
                      <VideoPopup
                        key={`media:${videoId}:${language}`}
                        className="ParagraphAvOWinners__item__video"
                        showIcon={false}
                        showTitle={false}
                        thumbnail={{
                          [SCREEN_MOBILE]: thumbnailMobile,
                          [SCREEN_NORMAL]: thumbnailDesktop,
                        }}
                        {...{ title, embedUrl }}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ParagraphAvOWinners;
